export default {
  name: 'LOGIN_FAIL',
  fields: {
    category: 'Login Form',
    action: 'Login Fail',
    label: '',
    value: 0,
    nonInteraction: false
  }
}



// WEBPACK FOOTER //
// ./src/analytics/Events/LoginFail.js